export default {
    RESTAURANT_MENU: 'menu',
    RESTAURANT_BUSINESS_HOURS: 'business_hours',
}
